import { defineStore } from "pinia";

export const usePaymentOnlineStore = defineStore('paymentOnline', {
	state: () => ({
		response: window.__pt.payload
	}),
	getters: {
		payment: (state) => state.response
	},
	actions: {
	}
});